import * as React from "react";
import type { SVGProps } from "react";
const SvgChartStyleBig = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={20}
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      stroke="#90A4AE"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M10 1v9M14.462 17.809 10 10"
    />
    <rect
      width={18}
      height={18}
      x={1}
      y={1}
      stroke="#90A4AE"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      rx={9}
    />
    <path
      stroke="#90A4AE"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m10 10 8.69-2.31"
    />
  </svg>
);
export default SvgChartStyleBig;
